import { useLayoutEffect, useRef, useState } from 'react'

const useIsOverflowing = <T extends HTMLElement>(deps: ReadonlyArray<unknown> = []) => {
  const ref = useRef<T>(null)
  const [isOverflowing, setIsOverflowing] = useState(false)

  useLayoutEffect(() => {
    const el = ref.current
    if (!el) return

    const measure = () => setIsOverflowing(el.scrollWidth > el.offsetWidth)
    measure()

    if (typeof ResizeObserver === 'undefined') return
    const observer = new ResizeObserver(measure)
    observer.observe(el)
    return () => observer.disconnect()
  }, deps)

  return [ref, isOverflowing] as const
}

export default useIsOverflowing
